/* eslint-disable */
import r1 from './r1.js'
import a from './a.js'

var s = function (e) {
  function i(e, t) {
    var n = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : {};
    return function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, i),
      function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (i.__proto__ || Object.getPrototypeOf(i)).call(this, e, t, n))
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(i, a.default),
    r1(i, [{
      key: "update",
      value: function (e) {
        (function e(t, n, i) {
          null === t && (t = Function.prototype);
          var r = Object.getOwnPropertyDescriptor(t, n);
          if (void 0 === r) {
            var o = Object.getPrototypeOf(t);
            return null === o ? void 0 : e(o, n, i)
          }
          if ("value" in r)
            return r.value;
          var a = r.get;
          return void 0 !== a ? a.call(i) : void 0
        }
        )(i.prototype.__proto__ || Object.getPrototypeOf(i.prototype), "update", this).call(this, e),
          this.visibility && !this.visible ? this.display() : !this.visibility && this.visible && this.hide()
      }
    }, {
      key: "display",
      value: function () {
        this.visible = !0
      }
    }, {
      key: "hide",
      value: function () {
        this.visible = !1
      }
    }]),
    i
}();
var t = { default: s }

export default t
